import { ProtocolContentData } from "../../protocol";
export default class PortOperations extends ProtocolContentData {
    portName;
    operationStatus;
    cargoType;
    cargoAmount;
    passengerCount;
    crewCount;
    freeText;
    constructor(portName, operationStatus, cargoType, cargoAmount, passengerCount, crewCount, freeText) {
        super();
        this.portName = portName;
        this.operationStatus = operationStatus;
        this.cargoType = cargoType;
        this.cargoAmount = cargoAmount;
        this.passengerCount = passengerCount;
        this.crewCount = crewCount;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=PortOperations.js.map